import { AfterViewInit, Component, ElementRef, ViewChild, inject } from '@angular/core';
import {VwuiModalConfig, VwuiModalRef} from '@bvgo-ict/vwui-angular';
import {FocusPicker} from 'image-focus';
import {BehaviorSubject} from 'rxjs';
import {map} from 'rxjs/operators';
import {PhotoFocus} from '../../models/photo-focus';
import {ProjectReferencePhoto} from '../../models/project-reference-photo';
import {highestWidthSrcsetSrc, srcsetToHtmlString} from '../../models/photo';

@Component({
    selector: 'app-focus-point-modal',
    styleUrls: ['./focus-point-modal.component.scss'],
    templateUrl: './focus-point-modal.component.html',
    standalone: false
})
export class FocusPointModalComponent implements AfterViewInit {
    modalRef = inject(VwuiModalRef);
    private modalConfig = inject<VwuiModalConfig<{
    projectReferencePhoto: ProjectReferencePhoto;
}>>(VwuiModalConfig);

    @ViewChild('focusSelector') focusSelectorEl!: ElementRef<HTMLImageElement>;

    projectReferencePhoto: ProjectReferencePhoto | undefined;

    focusPoint$ = new BehaviorSubject<PhotoFocus>({focusX: 0, focusY: 0});
    focusedPhoto$ = this.focusPoint$.pipe(
        map(focus => ({...this.projectReferencePhoto!, ...focus}))
    )

    constructor() {
        const modalConfig = this.modalConfig;

        this.projectReferencePhoto = modalConfig.data?.projectReferencePhoto
        this.focusPoint$.next(this.projectReferencePhoto!)
    }

    get imgSrc() {
        return this.projectReferencePhoto?.srcset
            ? highestWidthSrcsetSrc(this.projectReferencePhoto?.srcset ) : this.projectReferencePhoto?.originalUrl;
    }

    get imgSrcset() {
        return this.projectReferencePhoto?.srcset ? srcsetToHtmlString(this.projectReferencePhoto?.srcset) : undefined;
    }

    async saveFocusPoint({focusX, focusY}: ProjectReferencePhoto): Promise<void> {
        this.modalRef.close({focusX, focusY});
    }

    ngAfterViewInit(): void {
        new FocusPicker(this.focusSelectorEl.nativeElement, {
            onChange: ({x, y}) => this.focusPoint$.next({focusX: x, focusY: y}),
            focus: {x: this.projectReferencePhoto!.focusX, y: this.projectReferencePhoto!.focusY}
        });
    }
}
